import React from 'react';
import PropTypes from 'prop-types';
import * as Styled from './VHProfileImage.styled';

export const AvatarSizes = {
  SMALL: { width: 50, height: 50, borderRadius: 12 },
  MEDIUM: { width: 70, height: 70, borderRadius: 12 },
  LARGE: { width: 200, height: 200, borderRadius: 16 },
};

const VHProfileImage = (props) => {
  return (
    <Styled.Container width={props.size.width} height={props.size.height}>
      <Styled.Image
        width={props.size.width}
        height={props.size.height}
        borderRadius={props.size.borderRadius}
        src={props.src}
      />
    </Styled.Container>
  );
};

VHProfileImage.defaultProps = {
  size: AvatarSizes.MEDIUM,
};

VHProfileImage.propTypes = {
  src: PropTypes.string,
  size: PropTypes.shape({
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired,
  }).isRequired,
};

export default VHProfileImage;
